<div class="row">
  <div class="col-lg-12">
    <div class="card card-outline-success">
      <div class="card-header">
        <h4 class="m-b-0 text-white">Solicitud de transferencias</h4>
      </div>
      <div class="card-body">
        <div class="form-body">
          <h3 style="text-align: center">Solicitud de transferencias</h3>
          <h6 style="text-align: right">F01-OPEGC-001</h6>
          <br>
          <h5 style="text-align: right">Folio: numero</h5>
          <br>
          <!-- ==================== -->
          <!-- ===== Sucursal ===== -->
          <!-- ==================== -->
          <div class="col-lg-12 col-md-12">
            <label>Sucursal: </label>
            <select class="form-control col-md-8">
              <option>Corporativo/Cobranza</option>
              <option>Corporativo/Contabilidad</option>
              <option>Corporativo/Sistemas</option>
            </select>
          </div>
          <br>
          <!-- ==================== -->
          <!-- ===== Sucursal ===== -->
          <!-- ==================== -->
          <!-- ================= -->
          <!-- ===== Fecha ===== -->
          <!-- ================= -->
          <div class="col-lg-12 col-md-12">
            <label>Fecha: &nbsp; &nbsp; {{ fechaInicio }}</label>
          </div>
          <br>
          <!-- ================= -->
          <!-- ===== Fecha ===== -->
          <!-- ================= -->
          <!-- ============================ -->
          <!-- ===== Fecha y cantidad ===== -->
          <!-- ============================ -->
          <div class="col-lg-12 col-md-12">
            <label style="text-align: right">Fecha límite de pago: &nbsp; &nbsp; 10/17/2019</label>
            &nbsp; &nbsp;
            <label style="text-align: right">Pago: &nbsp; &nbsp; </label>
            <input class="form-control col-md-3" name="elPago" [(ngModel)]="pago" (ngModelChange)="millones(pago)">
          </div>
          <br>
          <!-- ============================ -->
          <!-- ===== Fecha y cantidad ===== -->
          <!-- ============================ -->
          <!-- ============================== -->
          <!-- ===== Cantidad con letra ===== -->
          <!-- ============================== -->
          <div class="col-lg-12 col-md-12">
            <label>Cantidad con letra: {{ letra }}</label>
          </div>
          <br>
          <!-- ============================== -->
          <!-- ===== Cantidad con letra ===== -->
          <!-- ============================== -->
          <!-- ======================= -->
          <!-- ===== A nombre de ===== -->
          <!-- ======================= -->
          <div class="col-lg-12 col-md-12">
            <label>A nombre de: &nbsp; &nbsp; </label>
            <input class="form-control col-md-8" name="aNombre">
          </div>
          <br>
          <!-- ======================= -->
          <!-- ===== A nombre de ===== -->
          <!-- ======================= -->
          <!-- ================= -->
          <!-- ===== Banco ===== -->
          <!-- ================= -->
          <div class="col-lg-12 col-md-12">
            <label>Banco: </label>
            <select class="form-control col-md-4">
              <option>Scotiabank</option>
              <option>Banorte</option>
              <option>Bancomer</option>
            </select>
            &nbsp; &nbsp;
            <label>Cuenta: </label>
            <select class="form-control col-md-4">
              <option>6878654</option>
              <option>3215488</option>
              <option>9898754</option>
            </select>
          </div>
          <br>
          <!-- ================= -->
          <!-- ===== Banco ===== -->
          <!-- ================= -->
          <!-- ================= -->
          <!-- ===== Clave ===== -->
          <!-- ================= -->
          <div class="col-lg-12 col-md-12">
            <label>Clabe: </label>
            <input class="form-control col-md-8" name="laClave">
          </div>
          <br>
          <!-- ================= -->
          <!-- ===== Clave ===== -->
          <!-- ================= -->
          <!-- ==================== -->
          <!-- ===== Contacto ===== -->
          <!-- ==================== -->
          <div class="col-lg-12 col-md-12">
            <label>Contacto: </label>
            <input class="form-control col-md-4" name="elContacto">
            <label>Tel: </label>
            <input class="form-control col-md-4" name="elTelefono">
          </div>
          <br>
          <!-- ==================== -->
          <!-- ===== Contacto ===== -->
          <!-- ==================== -->
          <!-- ================== -->
          <!-- ===== Correo ===== -->
          <!-- ================== -->
          <div class="col-lg-12 col-md-12">
            <label>Correo: </label>
            <input class="form-control col-md-4" name="elCorreo">
            <label>RFC: </label>
            <input class="form-control col-md-4" name="elRFC">
          </div>
          <br>
          <!-- ================== -->
          <!-- ===== Correo ===== -->
          <!-- ================== -->
          <!-- ========================== -->
          <!-- ===== No. de Factura ===== -->
          <!-- ========================== -->
          <div class="col-lg-12 col-md-12">
            <label>No. de factura: </label>
            <input class="form-control col-md-8" name="noFactura">
          </div>
          <br>
          <!-- ========================== -->
          <!-- ===== No. de Factura ===== -->
          <!-- ========================== -->
          <!-- ============================ -->
          <!-- ===== Concepto de pago ===== -->
          <!-- ============================ -->
          <div class="col-lg-12 col-md-12">
            <label>Concepto de pago: </label>
          </div>
          <br>
          <!-- ============================ -->
          <!-- ===== Concepto de pago ===== -->
          <!-- ============================ -->
          <!-- ======================= -->
          <!-- ===== Comentarios ===== -->
          <!-- ======================= -->
          <div class="col-lg-12 col-md-12">
            <label>Comentarios: </label>
            <textarea name="losComentarios" rows="8" cols="7"></textarea>
          </div>
          <br>
          <!-- ======================= -->
          <!-- ===== Comentarios ===== -->
          <!-- ======================= -->
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/formatos/solicitud-transferencias/solicitud-transferencias.component.html